import { EventBus } from '@primeuix/utils/eventbus';

var ConfirmationEventBus = EventBus();

export { ConfirmationEventBus as default };
//# sourceMappingURL=index.mjs.map
